import React ,{Component} from 'react';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system'; 
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Checkbox from '@mui/material/Checkbox';
import Customershipping from './Customershipaddress';
import Customerbilling from './Customeraddress';
import AttachmentIcon from '@mui/icons-material/Attachment';
import AddPaymentbox from './Addpayments';
let strCust=[{title:'',year:0}];


const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
const useStyles = styled(theme => ({
 
  root: {
    width: 500,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },

container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

export default class customerrefund extends Component {
constructor(props) {
    super();
	
	  var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	 
	  var strgoods=new Date();
   strgoods.setDate(strgoods.getDate() + 3);
   
	 this.state = {invoiceamtData:[],baloutstandingamt:'',scn_id:0,scnid:'',scnidarray:[],open:false,redirect:false,details:'',erropen:false,customerselectdtags:[],custid:'',creditnoteData:[],paymentdate:Date.now(),paymentdate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),ledgerdata:[],pvdata:[],
	 selectedcustomerexchange:[],showField:-1,reference:'',errormessage:'',previocn:"",sin_file:'',errortype:"error",invoiceno:'',grandtotal:"0.00",totaldata:0,pagename:'',btndisabled:false,submitbtn:"Save",customerarray:[],customerrauto:[],custtags:'',customer:[],custarray:[],ledgername:'',selectedcustomerid:'',
	ledger:'',ledgerlabel:'',granddiscount:"0.00",grandtotal:"0.00",grandpaid:"0.00",paid:"0.00",lefttoalocate:"0.00",sestatus:2,ind:0,custname:'',amount:"0.00"}
	  this.onTagscustomerexchange = this.onTagscustomerexchange.bind(this);
   this.updateDonenewParent = this.updateDonenewParent;
}	

 handlepaymentdate = (date) => {
	
	  var month="";
	  var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({		
		 paymentdate:dayjs(date),
paymentdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }	
 onFileChange=(e) =>{
	      let imageFile = e.target.files[0];

	   if (!imageFile.name.match(/\.(pdf)$/)) {
  alert( 'Please select valid file (pdf).' );
    return false;
  }else{
        this.setState({ imgCollection: e.target.files })
  }
        
    }
handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }

 myChangeHandler = (event) => {
  
  let nam = event.target.name;
  let val = event.target.value;	  
	   this.setState({[nam]: val});	    
   
}

componentWillMount() {

	document.title = "Isifol Account - Customer Refund";

if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			 this.ledgerbind();
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
	}
		    

}
PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=13')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
    this.ledgerbind();
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
onloadCustomerBind=(event)=>{

	 if(event.target.value.length>0 )
	{
	 axios.get(localStorage.getItem("ISIurl")+'ajaxcustomer.php?action=customerextender&cu_cmp_id='+localStorage.getItem("ISIcmpid")+'&cu_contactname='+event.target.value)
  .then(resp => { 
  this.setState({ custarray:resp.data});

	 var rowsArray = this.state.custarray;
	 rowsArray.map((row, i) => {
			 
		 const items = {
        title:row.title,
          year:row.year,
		  cuid:row.year,		  
		  rowindex:row.rowindex,
		  cu_contactname:row.cu_contactname,	
        };
		
		 const cusfound = strCust.some(el => el.year === row.year);
		 if (!cusfound) strCust.push(items)
		  
		 });
	
		  this.setState({customerrauto:strCust},
		  
		  ()=>{console.log(this.state.custarrauto)})
  });
	 
	}
} 
onTagscustomerexchange = (event, values) => {
	if(values!==" " && values!==null){
		this.setState({
		custid:values.year,
		 cuid:values.year,
			   country:values["country"],
		selectedcustomerexchange:values},()=>{this.apicall(this.state.cuid);})
		
	}
	
	else
	{
		 this.setState({ custid:'',cu_id:'',selectedcustomerexchange:[]})
	}
	
}
onInputCustChange = (event, newTextValue) => {
	if(newTextValue!==" "){
	  this.setState({custid:newTextValue})
	} 
	 
}
   handleCustomerInsertpopup= (e) => {
	  this.setState({ cuid: 0 });  
	 setTimeout(() => this.refs.AddCustomerbox.handleClickOpen(),500);
}
ledgerbind(){

 axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=getall&le_isbank=1&le_cmp_id='+localStorage.getItem("ISIcmpid"))
	 .then((resp) => {     
	  let LedgerApi = resp.data.map(row => {
                      
          return {value:row.le_id, display:row.le_code+" - "+row.le_ledgername}
        });
		 this.setState({
          ledgerdata: [{value:'0', display:'Select'}].concat(LedgerApi)
        });
		
		
      }).then(data => {

      })
  
}
apicall(Cuid) {
    let strInvoice = [];
    axios.get(localStorage.getItem("ISIurl") + 'ajaxsalescreditnote.php?action=getall&scn_status=' + this.state.sestatus + '&scn_cu_id=' + Cuid)
        .then(resp => {
            if (resp.data.length > 0) {
                resp.data.map((row, i) => {
                    const copTotal = parseFloat(row.cop_total) || 0;
                    const outstandingAmountFromDB = parseFloat(row.dueamount) || 0;

                    const items = {
                        isseleceted: "0",
                        paid: 0,
                        outstandingamt: outstandingAmountFromDB,
                        scn_id: row.scn_id, 
                        scn_quotenumber: row.scn_quotenumber,
                        scn_reference: row.scn_reference,
                        notedate: row.notedate,
                        cop_total: copTotal,
                        scn_status: row.scn_status,
                        scn_discount: parseFloat(row.scn_discount) || 0,
                    }
                    strInvoice.push(items)
                });
                this.setState({ creditnoteData: strInvoice }, () => { console.log(this.state.creditnoteData) });
                this.balamountbind(this.state.cuid);
            } else {
                this.setState({ creditnoteData: [], totaldata: 0 });
            }
        })
        .catch(error => {
            console.error("Error fetching credit note data:", error);
            this.setState({ erropen: true, errormessage: "Error loading credit notes. Please try again." });
        });
}

balamountbind(Cuid){	
    axios.get(localStorage.getItem("ISIurl")+'ajaxsalesinvoice.php?action=balamtrefundbycustid&scn_cu_id=' + Cuid)
    .then(resp => {  	
        if (resp.data !== null && resp.data !== undefined) {
            this.setState({  
                invoiceamtData: resp.data, 
                baloutstandingamt: parseFloat(resp.data).toFixed(2)
            });
        } else {
            this.setState({invoiceamtData: [], baloutstandingamt: 0.00});
        }
    })
 
}

handleAllInvoices = () => {
    let studArray = [...this.state.creditnoteData];

    this.setState({ allchecked: !this.state.allchecked }, () => {
        if (this.state.allchecked === false) {
            studArray.map((rowssub, j) => {
                rowssub.isseleceted = "0";
                rowssub.outstandingamt = parseFloat(rowssub.paid_when_checked || rowssub.cop_total);
                rowssub.paid = 0;
            });
        } else if (this.state.allchecked === true) {
          studArray.map((rowssub, j) => {
    rowssub.isseleceted = "1";
    rowssub.paid_when_checked = parseFloat(rowssub.outstandingamt) || 0;
    rowssub.paid = rowssub.paid_when_checked || 0;
   
});
        }

        this.setState({ creditnoteData: studArray }, () => {
            const optionsVals = this.state.creditnoteData;
            let Totalamount = 0;

            optionsVals.forEach(eachval => {
                if (eachval.isseleceted === "1") {
                    Totalamount += parseFloat(eachval.paid); 
                }
            });
            this.setState({ amount: Totalamount.toFixed(2) });
        });
    });
}

handleInvoice = (id, rowsd) => {
  const updatedArray = [...this.state.creditnoteData];

  if (updatedArray[rowsd].isseleceted === "0") {
    updatedArray[rowsd].isseleceted = "1";
    updatedArray[rowsd].paid_when_checked = parseFloat(updatedArray[rowsd].outstandingamt) || 0;
    updatedArray[rowsd].paid = updatedArray[rowsd].paid_when_checked;
    updatedArray[rowsd].outstandingamt = 0; 
    updatedArray[rowsd].scn_status = 4;  // Set status to 4
  } else {
    updatedArray[rowsd].isseleceted = "0";
    updatedArray[rowsd].outstandingamt = parseFloat(updatedArray[rowsd].paid_when_checked || updatedArray[rowsd].cop_total) || 0;
    updatedArray[rowsd].paid = 0;
    updatedArray[rowsd].scn_status = 1;  // Reset to original status
  }

  this.setState({ creditnoteData: updatedArray }, () => {
    const optionsVals = this.state.creditnoteData;
    let Totalamount = 0;

    optionsVals.forEach(eachval => {
      if (eachval.isseleceted === "1") {
        Totalamount += parseFloat(eachval.paid) || 0; 
      }
    });
    this.setState({ amount: Totalamount.toFixed(2) });
  });
} 
  handleClickSearch=(event)=>{
	    let nam = event.target.name;
  let val = event.target.value;	  
	   this.setState({[nam]: val});	
 this.apicall(this.state.cuid); 
}



onClickSalesSave = (event) => {
    let scn_id;

    let cuid = this.state.cuid,
        custname = this.state.custname,
        amount = this.state.amount,
        paymentdate1 = this.state.paymentdate1,
        bank = this.state.bank,
        paymenttype = this.state.paymenttype,
        reference = this.state.reference;
    let optionsVal = this.state.creditnoteData;
    let sep1 = "";
    let optionValues = "";

    optionsVal.forEach((eachval) => {
        if (eachval.isseleceted === "1") {
optionValues += sep1 + eachval.paid + "~" + eachval.scn_id + "~" + eachval.scn_discount+ "~" + 2;  
            sep1 = "`";
        }
    });

    console.log(optionValues);
	
		
	 if (!cuid || cuid==="0") {
        this.setState({ errormessage: "Please Select Customer", erropen: true });
        return false;
    }

     if (!bank || bank === "0") {
        this.setState({ errormessage: "Please Select Paid into", erropen: true });
        return false;
    }
    if (!paymenttype || paymenttype === "0") {
        this.setState({ errormessage: "Please Select Payment Method", erropen: true });
        return false;
    }

    if (paymentdate1 === "") {
        this.setState({ errormessage: "Please Select Payment Date", erropen: true, });
        window.scrollTo({ top: 0 });
        return false;
    }
 if (amount === "" ||amount === "0.00" ) {
        this.setState({ errormessage: "Please Select Outstanding Bills", erropen: true, });
        window.scrollTo({ top: 0 })
        return false;
    }
    this.setState({ btndisabled: true, submitbtn: "Processing..." });

    var formData = new FormData();

    formData.append('action', 'insert');
    formData.append('pmt_amount', amount);
    formData.append('pmt_paymentdate', paymentdate1);
    formData.append('pmt_ledger_id', bank);
    formData.append('pmt_paymenttype', paymenttype);
    formData.append('pmt_reference', reference);
    formData.append('pmt_type', 7); 
    formData.append('customerrciept', optionValues);
    formData.append('pmt_cmp_id', localStorage.getItem("ISIcmpid"));
  formData.append('userid', localStorage.getItem("ISIuserid"))
	formData.append('pmt_cu_id', this.state.cuid)

    axios.post(localStorage.getItem("ISIurl") + "ajaxcustomerreciept.php", formData, {
    }).then(res => {
        if (this.state.scn_id === 0) {
            this.setState({
                btndisabled: false,
                submitbtn: "Save",
                errortype: "success",
                errormessage: "Sales Customer receipt updated Successfully",
                amount: '0.00', 
                reference: '', 
                paymenttype: '', 
                bank: '', 
            }, () => {
                if (this.state.cuid) { 
                    this.apicall(this.state.cuid); 
                    this.balamountbind(this.state.cuid); 
                }
            });
        } else {
            this.setState({ redirect: true, pagename: '/Customereciept' });
        }
    }).catch(error => {
        console.error("Error saving customer refund:", error);
        this.setState({
            btndisabled: false,
            submitbtn: "Save",
            erropen: true,
            errortype: "error",
            errormessage: "Failed to save refund. Please check your inputs and try again.",
        });
    });
};
	  
  
  render() { 
let	granddiscount=0;
let grandtotal=0;
let grandpaid=0;let outstandingamt=0;

  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
    return (
	<React.Fragment> 
		<div className="contenttext">
	<div className="contenttexts tabbox">	 
		<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  <Customerbilling ref="AddCustomerbox" id={this.state.cuid}  billingupdateDone={this.updateDonenewParent}/>	

<ul>
		<li>
		<p>Search for a Customer<span className="validation">*</span></p>
		<p>
    <Autocomplete name="custname"
      id="free-solo-demo"
      
      className="txtbox"  inputValue={this.state.custid}
      options={this.state.customerrauto}   onInputChange={this.onInputCustChange}
	   onChange={this.onTagscustomerexchange} 
	    value={this.state.selectedcustomerexchange}
      renderInput={(params) => (
        <TextField {...params} className="txtbox" onChange={this.onloadCustomerBind}  variant="outlined" />
      )}
 getOptionLabel={(option) => option.title || ""}

      renderOption={(props, option: AcOption) => (
        <React.Fragment>
          <table width='200%' >
          
            <tbody>
              <tr {...props}>
                <td width='10%'>{option.title}</td>     
				
              </tr>
			  {option.rowindex=="1" &&(
			    <tr {...props}>
                <td width='10%'><span onClick={this.handleCustomerInsertpopup}>Add Customer</span></td>
         
				
              </tr>
			   )}
            </tbody>
          </table>
        </React.Fragment>
      )}
    />
	</p>

{(this.state.baloutstandingamt != "" && this.state.baloutstandingamt != "") && (<p className="custtext">
                                    This customer owe ${this.state.baloutstandingamt} outstanding.</p>
                                )}
</li>
<li>
<p>Paid Into Bank Account<span className="validation">*</span></p> 
<p> <Select
            native
            fullWidth
            variant="outlined"
            margin="normal"
            value={this.state.bank}
            onChange={this.myChangeHandler}
            inputProps={{ tabIndex: "4" }}
            className="txtbox"
            id="bank"
            name="bank"
          >
            {this.state.ledgerdata.map((ledger) => (
              <option key={ledger.value} value={ledger.value}>
                {ledger.display}
              </option>
            ))}
          </Select></p>
		 
</li>
<li>
<p>Method<span className="validation">*</span></p> 
<p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.myChangeHandler}
  id="paymenttype"
  value={this.state.paymenttype}
  name="paymenttype"
  inputProps={{tabIndex: "5"}}
        ><option value={0}>Please Select</option>
	<option value={1}>Cash</option>
	<option value={2}>Check</option>
	<option value={3}>Electronic</option>	
	<option value={4}>Credit/Debit</option>	
	<option value={5}>Paypal</option>
		
  </Select></p>
</li>

<li>	
						  
	<p>Date Refunded<span className="validation">*</span></p>
	
	<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
      <DatePicker
     value= {dayjs(this.state.paymentdate) }
      className="txtbox" 
     onChange={this.handlepaymentdate} format="MM/DD/YYYY"
       />  </DemoContainer>
     </LocalizationProvider></p>
	
		
</li>
<li>
		
	<p>Your Reference (optional)</p>
	
	
	<p><TextField name="reference" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.reference}
			  inputProps={{tabIndex: "6",maxLength:15}}
			  ref={this.usernameInput}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
              
		  /></p>
		  
		 
</li>
<li>	
						  
	<p>Amount Refunded<span className="validation">*</span></p>
		
	
	<p><TextField name="amount" 
	   onChange={this.myChangeHandler} 
	   fullWidth 
	   value={this.state.amount}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						   
		 
</li>
</ul>
</div>	  
<div className="searchboxs">
<ul>
<li>
<p className="popformtext">Display: </p><p className="popforminputs"><Select
 native
 variant="outlined" className="txtbox"
 margin="normal"
 fullWidth 
 onChange={this.myChangeHandler}
  id="role"
 value={this.state.sestatus}
 name="sestatus"
 inputProps={{tabIndex: "4"}}
    >
	<option value={1}>Outstanding</option>
	<option value={" "}>All</option>


	
</Select></p>
</li>
<li>
<p>&nbsp;</p>
	 <p className="searchbutton">
       <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
 
  Search 
</Button></p></li>
</ul>
</div>	  
<div className="ordtbl">
<Paper className={useStyles.root}>
 <TableContainer className={useStyles.container}>  
 <Table stickyHeader aria-label="sticky table"> 
 
 <TableHead> 
<TableRow>
   <TableCell width="5%">
<Checkbox 
 checked={this.state.allchecked}
  onChange={()=>{this.handleAllInvoices()}}
  inputProps={{ 'aria-label': 'controlled' }}
/>
 </TableCell>
  <TableCell width="14%"><b>Date</b></TableCell>     
  <TableCell width="13%"><b>Number</b></TableCell>  
  <TableCell width="14%"><b>Reference</b></TableCell> 
 <TableCell width="13%"><b>Type</b></TableCell>  
  <TableCell width="15%"><b>Total</b></TableCell>  
 <TableCell width="15%"><b>Outstanding</b></TableCell>    
    <TableCell width="13%"><b>Paid</b></TableCell> 

						
                      </TableRow></TableHead>

		   
               
                      <TableBody>
					  
 {(this.state.creditnoteData).map((item,index) => {

outstandingamt=parseFloat(outstandingamt)+parseFloat(item.outstandingamt)
grandtotal=parseFloat(item.paid)+parseFloat(grandtotal)     

				
           return ( <React.Fragment>
 
 <TableRow key={index} >

 <TableCell>
 {item.isseleceted==="0" && (
<Checkbox
  
  onChange={()=>{this.handleInvoice(item.scn_id,index)}}
  inputProps={{ 'aria-label': 'controlled' }}
/> 
)}{item.isseleceted==="1" && (
<Checkbox
  checked
  onChange={()=>{this.handleInvoice(item.scn_id,index)}}
  inputProps={{ 'aria-label': 'controlled' }}
/> 
)}


</TableCell>

<TableCell>
 
 {item.notedate} 
 
 </TableCell>  
 
 
          
 
  
<TableCell>
 {item.scn_quotenumber}

</TableCell>   

<TableCell>
 {item.scn_reference}
</TableCell>   

<TableCell>
<p>Crn</p>
</TableCell>  

<TableCell>
 {item.cop_total}
</TableCell> 
 
<TableCell>
    {item.isseleceted === "1" ? '0.00' : (parseFloat(item.outstandingamt) || 0).toFixed(2)}
</TableCell>
<TableCell>
    {parseFloat(item.paid).toFixed(2)} 
</TableCell>






 </TableRow>
 



 
 
				</React.Fragment>	
				);
					})}					  
					  
	<TableRow  >
	<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell colspan={1} align="right">

<TextField name="grandtotal" 
	   onChange={this.myChangeHandler} 
	   fullWidth disabled
    value={parseFloat(outstandingamt).toFixed(2)} 
			 
			
			  inputProps={{tabIndex: "1",maxLength:5}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></TableCell>

						  <TableCell colspan={1} align="right"><TextField name="grandtotal" 
	   onChange={this.myChangeHandler} 
	   fullWidth disabled
    value={parseFloat(grandtotal).toFixed(2)} 
			 
			
			  inputProps={{tabIndex: "3",maxLength:5}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></TableCell>

</TableRow>					  
<TableRow>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>	
	
<TableCell>Left to allocate </TableCell>	
 <TableCell colspan={1} align="right"><TextField name="lefttoalocate" 
	   onChange={this.myChangeHandler} 
	   fullWidth disabled
	   value={this.state.lefttoalocate}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></TableCell>
</TableRow>						  
	 </TableBody>



</Table>
  </TableContainer> 
 
  </Paper>
  <div className="salesactions">
   <p>
   <Button component="label"  className="frmSecondarybtn" name="st_profile"  onChange={this.onFileChange}   variant="contained"   accept="image/*;capture=camera" startIcon={<AttachmentIcon />}>
	
		Add File
		<VisuallyHiddenInput type="file"   /></Button>
		{this.state.previocn!="" && (
		<p><a href={localStorage.getItem("ISIurl")+"uploads/"+this.state.previocn} target="_blank">View</a></p>
		)}
		
		&nbsp;
		
   <Button variant="contained" disabled= {this.state.btndisabled} className="frmSecondarybtn" onClick={this.onClickSalesSave}>
	   {this.state.submitbtn}
</Button>&nbsp;
    <Button variant="contained" className="frmthirdbtn" onClick={this.onclickCancel}>
Cancel
</Button>
</p>
   </div>
   
   <div className="clear"></div>  
		</div>  
	     <div className="clear"></div>
	</div>

</React.Fragment>
	);
  }
	
}